import React from 'react';

import styled from 'styled-components';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { IPrice, IPriceAndCalories } from './types';

const StyledPriceAndCalories = styled.div<IPrice>`
  text-align: center;
  font-size: 1rem;
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.base};
  font-weight: ${Styles.fontWeight.normal};
  line-height: 1.2;
  margin: 0.5rem 0 1.75rem 0;
`;

const Seperator = styled.span`
  margin: 0 10px;
`;

/**
 * Conditionally hide site-wide calories based on an LD flag. All rendered calories outside of
 * the nutrition explorer should be wrapped with this component
 */
export const Calories: React.FC<{ children: React.ReactNode }> = props => {
  const hideUiCalories = useFlag(LaunchDarklyFlag.HIDE_UI_CALORIES);

  if (hideUiCalories) {
    return null;
  }
  return <>{props.children}</>;
};

const PriceAndCalories: React.FC<IPriceAndCalories> = props => {
  const showCalories = !props.shouldHideCalories;
  return (
    <StyledPriceAndCalories>
      <span data-testid="wizard-price">{props.currentPrice}</span>{' '}
      {showCalories && (
        <Calories>
          <Seperator> | </Seperator>
          <span data-testid="wizard-calories">{props.formattedCalories}</span>
        </Calories>
      )}
    </StyledPriceAndCalories>
  );
};

export default PriceAndCalories;
